<router-outlet />
<nr-toaster />
